import { useLanguage } from "@/i18n";
import { ASSETS } from "@/data";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#04060F] py-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 text-center sm:px-6 lg:px-8">
        <a href="#home" data-testid="footer-logo-link" className="flex items-center gap-3">
          <span className="pixel-corners-sm block h-9 w-9 overflow-hidden border border-cyan-400/40">
            <img src={ASSETS.logo} alt="NavX logo" className="h-full w-full object-cover" />
          </span>
          <span className="font-pixel text-sm tracking-widest text-white">NAVX</span>
        </a>
        <p className="text-xs uppercase tracking-[0.25em] text-slate-500">{t.footer.tagline}</p>
        <p data-testid="footer-rights" className="font-pixel text-[10px] tracking-[0.2em] text-slate-600">
          {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}
